import { render, staticRenderFns } from "./ChartOmoIcons.vue?vue&type=template&id=b5eebd9c"
import script from "./ChartOmoIcons.vue?vue&type=script&lang=ts"
export * from "./ChartOmoIcons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports